import { Button, Heading, Tooltip } from "@stacklet/ui";
import { useNavigate } from "react-router";

import { paths } from "app/constants/paths";
import { useHasScopePermission } from "app/hooks";

/**
 * Action bar for the Users settings page: the page title, and the create user
 * action. Search lives in the directory below (per view).
 */
export function UsersActionBar() {
  const navigate = useNavigate();
  const hasPermission = useHasScopePermission();
  const hasSystemEditPermission = hasPermission("system", "EDIT");

  return (
    <div className="mb-xl flex items-center justify-between gap-md">
      <Heading level={2}>Users</Heading>
      <Tooltip
        title={
          hasSystemEditPermission
            ? ""
            : "You need system edit permissions to create a user"
        }
        asChild
      >
        <span>
          <Button
            isDisabled={!hasSystemEditPermission}
            onPress={() => navigate(paths.userAdd)}
            variant="secondary"
          >
            Create User
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}
